import { Component } from '@angular/core';
import { DzModalConfig } from '@blk/daisy/modules/modals';

@Component({
	selector: 'app-loading-spinner',
	templateUrl: './loading-spinner.component.html',
	styleUrls: ['./loading-spinner.component.scss']
})

export class LoadingSpinnerComponent {
	public content: any;
	constructor(private config: DzModalConfig) {
		this.content = this.config.contentData;
	}
}
